var Bloodhound = require('bloodhound-js');

$(function () {  
  window.setTimeout(() => {
    $('.alert').alert('close')
  }, 15000)
  
  var engine = new Bloodhound({
    remote: {
      url: $('#search').data('url') + '?q=%QUERY%',
      wildcard: '%QUERY%'
    },
    datumTokenizer: Bloodhound.tokenizers.whitespace('q'),
    queryTokenizer: Bloodhound.tokenizers.whitespace
  });
  
  $("#search").typeahead({
    hint: true,
    highlight: true,
    minLength: 1
  }, {
    source: engine.ttAdapter(),
    
    // This will be appended to "tt-dataset-" to form the class name of the suggestion menu.
    name: 'usersList',
    displayKey: 'name',
    // the key from the array we want to display (name,id,email,etc...)
    templates: {
      empty: function(q) {
        return '<div class="list-group search-results-dropdown"><div class="list-group-item">Aucun résultat trouvé pour « '+ q.query +' »</div></div>'
      },    
      header: [
        '<div class="list-group search-results-dropdown">'
      ],
      suggestion: function (data) {
        return '<a href="' + data.url + '" class="list-group-item">' + data.name + '</a>'
      }
    }
  })
  
  $('#search').bind('typeahead:select', function(ev, suggestion) {
    location.href = suggestion.url
  })
  
  $('.delete-attachment').on('click', function(e) {
    const $this = $(this)
    const message = $this.data('message')
    const title = $this.data('title')
    urlDeleteAttachmentProject = $this.data('url')
    elementRemove = $this.data('classremove')
    bootbox.confirm({
      message: message,
      title: title,
      buttons: {
        confirm: {
          label: 'Oui',
          className: 'btn btn-secondary'
        },
        cancel: {
          label: 'Annuler',
          className: 'btn'
        }
      },
      callback: function (result) {
        if (result) {
          return axios.post(urlDeleteAttachmentProject)
          .then((response) => {  
            $('.' + elementRemove).remove()
          })
        }
      }
    })
    e.preventDefault()
  })
})



// WEBPACK FOOTER //
// ./resources/assets/js/components/alerts.js